import React from "react";

const Logo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="2.222in"
    height="0.875in"
    viewBox="0 0 888 350"
    className="site-logo"
  >
    <path
      id="Selection"
      fill="white"
      stroke="black"
      strokeWidth="0.5"
      d="M 160.00,202.33
           C 154.34,206.79 146.33,211.40 139.00,211.90
             135.23,212.16 131.47,211.37 128.00,209.90
             111.96,203.08 112.43,184.20 119.49,171.00
             122.59,165.20 129.26,155.47 136.96,156.89
             144.13,158.22 142.15,168.27 140.12,173.00
             138.07,177.78 135.03,181.37 131.00,184.62
             129.20,186.08 125.06,188.33 124.23,190.33
             122.81,193.76 127.51,198.69 130.02,200.49
             131.89,201.84 133.71,202.54 136.00,202.80
             141.20,203.38 146.82,200.65 151.00,197.78
             159.62,191.85 170.57,178.73 174.64,169.00
             176.05,165.64 176.67,156.13 177.07,152.00
             177.07,152.00 180.66,130.00 180.66,130.00
             187.61,96.33 199.56,49.66 218.24,21.00
             220.02,18.27 222.06,15.70 224.43,13.47
             226.08,11.91 227.84,10.51 230.00,9.72
             246.23,3.86 248.98,23.92 249.00,35.00
             249.03,52.27 244.12,74.58 238.67,91.00
             234.56,103.36 229.72,115.41 223.74,127.00
             223.74,127.00 215.00,143.00 215.00,143.00
             218.33,143.20 223.76,143.99 222.16,148.87
             220.87,152.78 214.78,152.04 213.99,157.02
             213.59,159.54 216.18,163.82 217.43,166.00
             220.86,172.00 225.65,178.64 228.00,185.00
             233.99,179.29 243.65,172.06 251.00,168.26
             251.00,168.26 262.00,162.94 262.00,162.94
             266.33,160.47 271.40,154.90 276.94,157.40
             287.78,162.29 275.66,180.02 270.00,184.62
             268.17,186.10 264.05,188.35 263.15,190.33
             261.30,194.42 268.41,203.75 278.00,202.80
             290.14,201.61 303.62,185.82 309.55,176.00
             311.57,172.65 315.72,161.77 320.71,163.66
             323.55,164.72 323.82,169.46 323.97,172.00
             323.97,172.00 325.30,190.00 325.30,190.00
             325.60,191.86 326.32,195.05 328.30,195.84
             331.59,197.17 335.85,191.18 337.58,189.00
             337.58,189.00 352.09,168.87 352.09,168.87
             357.57,163.93 361.30,169.82 362.24,175.00
             362.24,175.00 363.00,181.00 363.00,181.00
             363.00,181.00 364.00,192.00 364.00,192.00
             366.52,190.95 372.10,188.59 372.85,193.15
             373.43,196.70 367.29,203.23 365.64,209.00
             365.64,209.00 364.00,235.00 364.00,235.00
             363.90,257.26 356.34,295.74 345.39,315.00
             341.26,322.26 336.32,331.00 328.91,335.33
             318.39,341.49 311.15,335.29 311.00,324.00
             311.00,324.00 311.00,319.00 311.00,319.00
             311.11,309.76 314.59,300.69 317.49,292.00
             324.12,272.10 333.89,250.82 343.25,232.00
             346.04,226.37 355.05,209.93 355.79,205.00
             356.40,200.99 355.76,196.98 355.28,193.00
             354.63,187.53 355.52,187.44 353.00,182.00
             349.89,188.37 341.88,200.10 335.91,203.87
             331.30,206.78 324.62,207.01 320.80,202.66
             316.37,197.61 316.83,189.25 315.00,183.00
             308.44,195.75 290.44,212.96 275.00,211.90
             255.74,210.59 250.04,191.90 256.00,176.00
             256.00,176.00 232.00,192.00 232.00,192.00
             232.00,192.00 235.53,204.00 235.53,204.00
             237.56,214.80 235.42,227.61 227.67,235.82
             215.48,248.74 198.96,236.98 200.33,221.00
             200.99,213.18 204.58,206.01 209.47,200.00
             211.29,197.75 217.88,191.55 218.37,189.58
             218.96,187.20 215.76,182.11 214.58,180.00
             210.56,172.83 206.90,165.68 204.00,158.00
             195.11,174.58 182.22,174.68 182.00,193.00
             182.00,193.00 181.00,221.00 181.00,221.00
             181.00,221.00 182.00,236.00 182.00,236.00
             182.00,236.00 184.58,271.00 184.58,271.00
             184.58,271.00 188.71,304.00 188.71,304.00
             189.93,308.04 193.94,313.73 188.71,316.97
             184.94,319.33 182.20,316.46 181.11,312.98
             181.11,312.98 177.87,288.00 177.87,288.00
             177.87,288.00 173.00,234.00 173.00,234.00
             173.00,234.00 173.00,187.00 173.00,187.00
             170.28,192.86 165.05,198.35 160.00,202.33 Z
           M 204.67,143.00
           C 220.36,119.45 233.95,86.03 238.27,58.00
             239.90,47.47 241.05,38.71 240.00,28.00
             239.73,25.31 238.65,18.62 235.59,17.71
             232.25,16.73 228.15,21.75 226.43,24.04
             221.22,30.97 216.00,41.93 212.58,50.00
             201.87,75.24 194.75,103.11 189.74,130.00
             189.74,130.00 184.00,168.00 184.00,168.00
             191.74,162.34 199.30,151.05 204.67,143.00 Z
           M 51.83,225.00
           C 51.83,225.00 49.28,242.00 49.28,242.00
             49.28,242.00 45.25,270.00 45.25,270.00
             44.39,275.28 43.91,285.02 42.38,289.00
             41.52,291.23 40.25,294.50 37.79,295.34
             34.62,296.43 32.49,293.92 32.19,290.98
             32.19,290.98 35.73,272.00 35.73,272.00
             35.73,272.00 40.71,240.00 40.71,240.00
             40.71,240.00 42.44,224.00 42.44,224.00
             42.44,224.00 45.82,194.04 45.82,194.04
             45.22,189.01 40.98,189.20 37.00,188.45
             25.21,186.72 25.84,186.45 14.00,188.45
             10.57,188.86 5.64,187.66 6.74,183.10
             7.46,180.14 16.99,174.68 19.83,172.42
             24.30,168.87 46.05,148.72 48.40,145.00
             50.16,142.22 50.95,129.79 51.00,126.00
             51.00,126.00 51.00,103.00 51.00,103.00
             51.00,103.00 48.17,69.00 48.17,69.00
             47.46,61.89 45.77,47.43 43.39,41.02
             41.31,35.43 38.12,36.54 36.60,32.86
             34.83,28.58 37.61,22.10 43.00,23.66
             50.55,25.84 53.82,44.03 54.87,51.00
             60.15,86.11 59.00,99.42 59.00,134.00
             64.43,130.10 76.11,116.95 81.12,111.42
             95.74,95.27 109.38,78.50 122.37,61.00
             122.37,61.00 135.90,42.04 135.90,42.04
             137.64,39.90 140.58,36.68 143.73,37.71
             147.73,39.01 146.55,44.20 144.58,46.72
             144.58,46.72 139.76,52.04 139.76,52.04
             139.76,52.04 124.13,74.00 124.13,74.00
             124.13,74.00 79.72,127.00 79.72,127.00
             75.03,132.31 63.02,143.08 60.28,148.00
             57.71,152.60 57.50,166.83 56.98,173.00
             56.66,175.84 55.47,180.12 56.98,182.61
             58.72,185.33 65.01,187.31 68.00,188.81
             75.67,192.64 83.12,197.27 90.00,202.38
             110.67,217.73 126.90,237.90 145.00,256.00
             145.00,256.00 161.17,272.78 161.17,272.78
             161.17,272.78 167.38,277.49 167.38,277.49
             170.09,280.90 166.77,285.39 162.00,284.29
             158.09,283.40 153.78,278.77 151.00,276.00
             151.00,276.00 130.00,254.00 130.00,254.00
             116.18,240.15 103.41,224.80 88.00,212.67
             78.00,204.80 66.70,199.64 56.00,193.00
             56.00,193.00 51.83,225.00 51.83,225.00 Z
           M 402.00,150.00
           C 402.00,150.00 448.00,150.00 448.00,150.00
             446.89,157.96 438.47,165.85 433.42,172.00
             433.42,172.00 399.00,214.00 399.00,214.00
             399.00,214.00 430.00,214.00 430.00,214.00
             430.00,214.00 448.00,215.00 448.00,215.00
             448.00,215.00 448.00,217.00 448.00,217.00
             448.00,217.00 428.00,218.00 428.00,218.00
             428.00,218.00 393.00,218.00 393.00,218.00
             394.09,210.21 401.18,204.03 405.88,198.00
             405.88,198.00 441.00,154.00 441.00,154.00
             441.00,154.00 393.00,154.00 393.00,154.00
             394.71,149.13 397.36,150.01 402.00,150.00 Z
           M 466.61,150.84
           C 469.40,151.64 472.59,161.12 473.86,164.00
             473.86,164.00 486.42,193.00 486.42,193.00
             486.42,193.00 494.00,211.00 494.00,211.00
             494.00,211.00 503.72,189.00 503.72,189.00
             503.72,189.00 507.26,178.00 507.26,178.00
             507.26,178.00 497.00,151.00 497.00,151.00
             497.00,151.00 502.00,151.00 502.00,151.00
             502.00,151.00 511.00,172.00 511.00,172.00
             511.00,172.00 520.00,151.00 520.00,151.00
             520.00,151.00 525.00,151.00 525.00,151.00
             525.00,151.00 514.22,177.58 514.22,177.58
             514.22,177.58 517.58,188.00 517.58,188.00
             517.58,188.00 528.00,211.00 528.00,211.00
             528.00,211.00 547.42,165.00 547.42,165.00
             547.42,165.00 554.49,151.02 554.49,151.02
             554.49,151.02 558.00,150.00 558.00,150.00
             556.96,156.63 553.62,162.84 551.00,169.00
             551.00,169.00 536.23,203.00 536.23,203.00
             534.81,206.11 530.89,219.22 526.37,217.38
             524.17,216.48 522.35,211.16 521.42,209.00
             521.42,209.00 511.00,185.00 511.00,185.00
             511.00,185.00 500.28,209.00 500.28,209.00
             499.25,211.40 497.60,216.47 494.90,217.27
             491.04,218.41 486.69,205.92 485.42,203.00
             485.42,203.00 463.00,150.84 463.00,150.84
             464.27,150.72 465.23,150.21 466.61,150.84 Z
           M 585.00,150.00
           C 585.00,150.00 585.00,218.00 585.00,218.00
             585.00,218.00 581.00,218.00 581.00,218.00
             581.00,218.00 581.00,150.00 581.00,150.00
             581.00,150.00 585.00,150.00 585.00,150.00 Z
           M 631.00,216.64
           C 617.09,210.64 609.06,195.85 610.09,181.00
             611.06,166.97 619.77,153.95 634.00,150.68
             646.37,147.84 665.28,152.13 667.00,167.00
             660.90,165.98 661.37,162.71 655.99,158.79
             648.74,153.50 639.01,152.52 631.00,156.71
             604.12,170.78 614.02,208.62 637.00,213.61
             643.80,215.09 651.38,213.18 657.00,209.20
             662.32,205.43 662.31,202.11 669.00,201.00
             665.28,216.02 644.22,222.35 631.00,216.64 Z
           M 697.00,150.00
           C 697.00,150.00 697.00,190.00 697.00,190.00
             697.00,190.00 725.00,162.00 725.00,162.00
             729.72,157.28 734.13,151.11 741.00,150.00
             738.92,157.09 727.58,166.27 722.26,172.28
             720.71,174.03 716.26,178.03 716.16,180.17
             716.04,182.76 721.39,188.77 723.11,190.96
             728.66,198.04 740.02,210.33 743.00,218.00
             735.72,217.41 734.50,213.40 730.20,208.00
             725.43,202.02 715.04,187.11 709.00,184.00
             709.00,184.00 698.02,198.00 698.02,198.00
             698.02,198.00 697.00,218.00 697.00,218.00
             697.00,218.00 693.00,218.00 693.00,218.00
             693.00,218.00 693.00,150.00 693.00,150.00
             693.00,150.00 697.00,150.00 697.00,150.00 Z
           M 764.00,159.00
           C 764.02,150.36 764.36,150.02 773.00,150.00
             773.00,150.00 809.00,150.00 809.00,150.00
             809.00,150.00 809.00,154.00 809.00,154.00
             809.00,154.00 769.00,154.00 769.00,154.00
             769.00,154.00 769.00,181.00 769.00,181.00
             769.00,181.00 797.00,181.00 797.00,181.00
             798.52,181.03 804.88,181.22 802.83,184.46
             801.80,186.08 798.67,185.96 797.00,186.00
             797.00,186.00 769.00,186.00 769.00,186.00
             769.00,186.00 769.00,214.00 769.00,214.00
             769.00,214.00 810.00,214.00 810.00,214.00
             808.55,218.14 807.15,217.92 803.00,218.00
             803.00,218.00 764.00,218.00 764.00,218.00
             764.00,218.00 764.00,159.00 764.00,159.00 Z
           M 867.00,150.53
           C 869.50,151.12 871.91,152.30 873.98,153.80
             886.61,162.88 886.47,186.43 867.00,192.00
             871.21,198.32 880.63,211.24 882.00,218.00
             872.23,216.34 868.79,199.46 861.48,193.60
             858.23,190.99 843.74,192.00 839.00,192.00
             839.00,192.00 839.00,218.00 839.00,218.00
             839.00,218.00 835.00,218.00 835.00,218.00
             835.00,218.00 835.00,150.00 835.00,150.00
             835.00,150.00 867.00,150.53 867.00,150.53 Z
           M 860.00,188.00
           C 864.62,187.98 867.95,188.00 871.82,185.01
             879.87,178.79 880.04,165.31 872.67,158.53
             865.72,152.13 848.33,154.00 839.00,154.00
             839.00,154.00 839.00,188.00 839.00,188.00
             839.00,188.00 860.00,188.00 860.00,188.00 Z
           M 28.00,179.00
           C 28.00,179.00 47.00,181.00 47.00,181.00
             47.00,181.00 49.00,158.00 49.00,158.00
             44.18,161.45 30.40,174.03 28.00,179.00 Z
           M 132.00,167.00
           C 132.00,167.00 133.00,168.00 133.00,168.00
             133.00,168.00 133.00,167.00 133.00,167.00
             133.00,167.00 132.00,167.00 132.00,167.00 Z
           M 127.00,176.00
           C 130.57,173.11 131.04,172.49 132.00,168.00
             132.00,168.00 127.00,176.00 127.00,176.00 Z
           M 265.00,177.00
           C 269.03,173.94 269.94,172.98 271.00,168.00
             271.00,168.00 265.00,177.00 265.00,177.00 Z
           M 209.63,221.00
           C 209.16,225.10 209.99,230.85 215.02,231.58
             219.26,232.20 222.28,228.24 224.05,225.00
             228.78,216.61 228.26,207.37 224.05,199.00
             216.29,204.52 210.75,211.33 209.63,221.00 Z
           M 343.76,251.00
           C 336.20,266.34 326.29,288.61 322.13,305.00
             319.94,313.59 317.84,320.12 320.00,329.00
             330.28,327.03 336.85,313.93 340.71,305.00
             349.77,284.03 356.00,249.87 356.00,227.00
             351.58,232.33 347.12,244.16 343.76,251.00 Z
           M 508.00,253.00
           C 508.00,253.00 508.00,263.00 508.00,263.00
             509.64,262.31 511.22,261.56 513.00,261.28
             524.25,259.56 522.00,274.05 522.00,281.00
             522.00,281.00 519.00,281.00 519.00,281.00
             519.00,277.05 519.70,267.23 515.70,265.08
             514.52,264.44 513.30,264.51 512.10,265.08
             506.90,267.55 508.00,276.22 508.00,281.00
             508.00,281.00 505.00,281.00 505.00,281.00
             505.00,281.00 505.00,253.00 505.00,253.00
             505.00,253.00 508.00,253.00 508.00,253.00 Z
           M 756.00,260.00
           C 756.08,255.85 755.86,254.45 760.00,253.00
             760.00,253.00 760.00,263.00 760.00,263.00
             761.82,262.16 762.94,261.52 765.00,261.24
             775.88,259.76 773.00,274.17 773.00,281.00
             773.00,281.00 771.00,281.00 771.00,281.00
             771.00,276.91 771.92,267.27 767.72,265.08
             766.50,264.44 765.28,264.51 764.05,265.08
             758.74,267.53 760.00,276.13 760.00,281.00
             760.00,281.00 756.00,281.00 756.00,281.00
             756.00,281.00 756.00,260.00 756.00,260.00 Z
           M 576.00,254.00
           C 576.00,254.00 576.00,261.00 576.00,261.00
             576.00,261.00 580.00,261.00 580.00,261.00
             580.00,261.00 580.00,264.00 580.00,264.00
             580.00,264.00 576.00,264.00 576.00,264.00
             576.00,264.00 577.00,279.00 577.00,279.00
             577.00,279.00 582.00,278.00 582.00,278.00
             579.89,281.50 575.65,283.16 573.57,278.66
             572.58,276.51 573.25,270.76 572.86,268.04
             572.49,265.47 571.05,263.32 570.00,261.00
             573.21,258.86 572.86,257.53 574.00,254.00
             574.00,254.00 576.00,254.00 576.00,254.00 Z
           M 478.04,260.98
           C 491.81,258.45 492.76,283.03 479.00,281.62
             476.69,281.39 474.92,280.14 473.00,279.00
             473.00,279.00 473.00,289.00 473.00,289.00
             473.00,289.00 470.00,289.00 470.00,289.00
             470.00,289.00 470.00,261.00 470.00,261.00
             470.00,261.00 474.00,263.00 474.00,263.00
             475.43,262.00 476.22,261.32 478.04,260.98 Z
           M 614.41,269.00
           C 615.81,275.55 609.87,282.76 603.00,281.57
             593.12,279.84 590.97,263.60 604.00,260.86
             609.22,261.25 613.22,263.51 614.41,269.00 Z
           M 639.00,281.67
           C 625.80,282.52 625.84,258.54 640.00,260.98
             641.82,261.29 643.38,262.19 645.00,263.00
             645.00,263.00 648.00,261.00 648.00,261.00
             648.00,265.91 648.78,281.36 646.83,284.94
             643.66,290.76 632.81,292.25 630.00,283.00
             636.35,285.68 643.17,290.19 645.00,279.00
             643.00,280.31 641.52,281.51 639.00,281.67 Z
           M 697.00,260.80
           C 705.49,260.85 704.80,267.97 705.02,274.00
             705.16,277.18 705.50,278.74 705.02,282.00
             697.75,279.69 695.76,283.62 691.15,280.26
             687.06,277.29 687.79,272.51 692.06,270.17
             694.72,268.71 698.99,269.00 702.00,269.00
             698.71,262.46 695.88,263.30 690.00,266.00
             690.00,266.00 689.00,263.00 689.00,263.00
             691.39,262.08 694.42,260.79 697.00,260.80 Z
           M 552.87,262.74
           C 558.31,266.60 559.07,277.42 550.00,280.99
             539.83,284.99 530.85,268.78 543.04,261.74
             546.44,260.91 549.81,260.56 552.87,262.74 Z
           M 668.00,264.00
           C 668.00,264.00 675.00,261.00 675.00,261.00
             675.00,261.00 669.17,268.11 669.17,268.11
             669.17,268.11 668.00,281.00 668.00,281.00
             668.00,281.00 665.00,281.00 665.00,281.00
             665.00,281.00 665.00,261.00 665.00,261.00
             665.00,261.00 668.00,264.00 668.00,264.00 Z
           M 726.00,263.00
           C 728.38,261.46 730.05,260.79 733.00,261.24
             745.43,263.14 742.13,284.02 730.00,281.54
             727.88,281.10 726.72,280.14 725.00,279.00
             725.00,279.00 725.00,289.00 725.00,289.00
             725.00,289.00 722.00,289.00 722.00,289.00
             722.00,289.00 722.00,261.00 722.00,261.00
             722.00,261.00 726.00,263.00 726.00,263.00 Z
           M 791.00,261.00
           C 791.00,261.00 798.00,277.00 798.00,277.00
             799.43,271.69 801.34,263.01 807.00,261.00
             807.00,261.00 796.01,287.52 796.01,287.52
             796.01,287.52 792.00,290.00 792.00,290.00
             792.00,290.00 794.89,280.57 794.89,280.57
             794.89,280.57 788.00,261.00 788.00,261.00
             788.00,261.00 791.00,261.00 791.00,261.00 Z
           M 480.98,278.35
           C 487.80,276.24 488.41,262.52 477.06,264.60
             469.04,269.50 474.19,280.44 480.98,278.35 Z
           M 548.96,278.22
           C 555.63,275.94 556.11,263.32 545.10,264.45
             535.88,268.68 541.68,280.71 548.96,278.22 Z
           M 606.89,278.13
           C 612.73,275.75 613.35,262.50 602.11,264.60
             593.74,269.91 599.99,280.94 606.89,278.13 Z
           M 640.89,278.22
           C 646.51,276.20 647.61,262.46 636.11,264.60
             627.67,269.96 634.11,280.66 640.89,278.22 Z
           M 731.99,278.46
           C 739.52,277.20 740.69,263.27 729.06,264.45
             721.76,267.76 724.71,279.69 731.99,278.46 Z
           M 697.94,278.38
           C 702.33,276.81 703.75,270.19 695.06,271.61
             688.33,275.75 693.65,279.92 697.94,278.38 Z"
    />
  </svg>
);

export default Logo;
